import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        entrantSort();

        function entrantSort() {
            // gets array of race numbers + the table data
            const raceNums = Array.from(document.getElementsByClassName("race-num"));
            const raceEntrantsTable = document.getElementById("table-body");

            const sortedRaceNumArray = sortArray(raceNums);
            // racenum => newindex
            const sortedRaceIndexMap = storeArrayIndexes(sortedRaceNumArray);
            // row => newindex
            const sortedRowsMap = orderEntrantsArray(sortedRaceIndexMap, raceEntrantsTable);
            orderTable(raceEntrantsTable, sortedRowsMap);
        }

        
        function sortArray(array) {
            //filters everything that isnt N/A
            const antiFilteredArray = array.filter(x => !nanFilter(x));
            // N/A values are taken out, numerical list is sorted, N/A values placed last.
            return array.filter(nanFilter).sort((a, b) => a.textContent - b.textContent ).concat(antiFilteredArray);
        }

        function nanFilter(a){
            return (a.textContent !== "N/A")
        }

        // maps each item to its index in the array given
        function storeArrayIndexes(array) {
            const indexOrderMap = new Map();
            for (let i = 0; i < array.length; i++) {
                indexOrderMap.set(array[i], i);
            }
            return indexOrderMap;
        }

        // maps the table rows with each of the sorted index - based off the raceNum sorted array
        function orderEntrantsArray(sortedRaceIndexMap, raceEntrantsTable) {
            const sortedEntrantsMap = new Map();
            for (let i = 0; i < raceEntrantsTable.rows.length; i++) {
                const row = raceEntrantsTable.rows[i];
                // accesses race number of row
                const entrantKey = row.cells[0];
                //gets sorted index of row
                const sortedRowIndex = sortedRaceIndexMap.get(entrantKey);
                //maps row with the sorted index
                sortedEntrantsMap.set(row, sortedRowIndex);
            }
            return sortedEntrantsMap;
        }

        // sorts the rows into the sorted order within an array,
        // then moves table rows to the bottom of the table in the order defined by the sorted array
        function orderTable(raceEntrantsTable, sortedRowsMap) {
            const sortedRowArray = new Array(sortedRowsMap.size);
            for (let i = 0; i < sortedRowsMap.size; i++) {
                const currentRow = raceEntrantsTable.rows[i];
                //get the sorted position of the current row
                const newRowIndex = sortedRowsMap.get(currentRow);
                //fills out the sortedRowArray in the correct order
                sortedRowArray[newRowIndex] = currentRow;
            }

            for (let i = 0; i < sortedRowArray.length; i++) {
                //moves the row to the bottom of the table
                sortedRowArray[i].parentNode.insertBefore(sortedRowArray[i], null);
            }
        }
    }
}